// Predicates for "is it worth doing background work right now".
//
// Background polls that fire on a hidden tab or an offline device can't produce
// anything the user is looking at, but on mobile they still wake the cellular
// radio out of idle — which it then holds for a 10-20s tail. That tail, not the
// payload, is what drains the battery, so a poll skipped here is the cheapest
// win available. Pair every skip with a visibilitychange resync so nothing is
// silently missed.

/** True when the tab is not the one the user is looking at. */
export const isHidden = () =>
  typeof document !== 'undefined' && document.visibilityState !== 'visible';

/**
 * True only when the browser is *sure* it is offline. `navigator.onLine === true`
 * is famously optimistic (it means "has a link", not "can reach the server"), so
 * this deliberately only trusts the negative — a false negative just means we
 * attempt a request that fails as it would have anyway.
 */
export const isOffline = () =>
  typeof navigator !== 'undefined' && navigator.onLine === false;

/** Skip a background poll: hidden tab or known-offline device. */
export const shouldSkipBackgroundWork = () => isHidden() || isOffline();
